import gettext from '@/gettext';
import type { Rule as AntRule } from 'ant-design-vue/es/form';
import type { Rule } from 'async-validator';

const { $gettext } = gettext;

export const oldPasswordMinLengthRule: Rule & AntRule = { min: 5, message: $gettext('Minimum 5 characters.') };
